import { render, staticRenderFns } from "./SkillDiagnosisBody.vue?vue&type=template&id=1edbfed3"
import script from "./SkillDiagnosisBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkillDiagnosisBody.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports